import { render, staticRenderFns } from "./SectionSelectionSundayResults.vue?vue&type=template&id=774d862e&"
import script from "./SectionSelectionSundayResults.vue?vue&type=script&lang=js&"
export * from "./SectionSelectionSundayResults.vue?vue&type=script&lang=js&"
import style0 from "./SectionSelectionSundayResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports